enum RGBA {
  rgba = 'rgba',
}
export const getRGBA = (
  R: number,
  G: number,
  B: number,
  A: number | string = 1,
) => {
  if (typeof A === 'string') {
    return convertRGBA(R, G, B, parseInt(A, 16) / 255);
  }
  return convertRGBA(R, G, B, A);
};
const convertRGBA = (R: number, G: number, B: number, A: number) =>
  `${RGBA.rgba}(${R}, ${G}, ${B}, ${A})`;

export const hexToRGB = (
  hex: string,
  alpha: string | number | undefined = undefined,
) => {
  if (hex) {
    const r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);
    if (typeof alpha === 'number' && alpha === 0) {
      return convertRGBA(r, g, b, alpha);
    }
    if (alpha) {
      return getRGBA(r, g, b, alpha);
    } else {
      return getRGBA(r, g, b);
    }
  }
  return getRGBA(0, 0, 0);
};

export const getClickableTextColor = (
  bgColor: string,
  importance: number,
  disabled = false,
) => {
  let color;
  switch (bgColor) {
    case 'dark':
      switch (importance) {
        case 1:
          color = '#46CBC0';
          break;
        case 2:
          color = '#a8f0ea';
          break;
        default:
          color = '#abd1ce';
          break;
      }
      break;
    default:
      switch (importance) {
        case 1:
          color = '#34b9ae';
          break;
        case 2:
          color = '#1a7075';
          break;
        default:
          color = '#5d8e8f';
          break;
      }
      break;
  }
  return color + (disabled ? 'cc' : '');
};
